import { gql } from '@src/__generated__';

export const GET_CLIENTS = gql(`
  query ClientQuery {
    allClients {
      id
      firstName
      lastName
      status
      email
      phone
      avatar
    }
  }
`);

// TODO !
// export const GET_TRIP_PROFILE = gql(`
//   query TripProfile($id: ID!) {
//     singleTripProfile(id: $id) {
//       clientId
//       id
//       title
//       country
//       destinationId
//       destination
//       destinationLat
//       destinationLong
//       status
//       startDate
//       endDate
//     }
//   }
// `);

export const UPSERT_CLIENT = gql(`
  mutation UpsertClient(
    $id: ID
    $firstName: String!
    $lastName: String!
    $status: ClientStatus
    $email: String
    $phone: String
    $avatar: String
  ) {
    upsertClient(
      id: $id
      firstName: $firstName
      lastName: $lastName
      status: $status
      email: $email
      phone: $phone
      avatar: $avatar
    ) {
      id
      firstName
      lastName
      status
      email
      phone
      avatar
    }
  }
`);
